import Backbone from 'backbone';

export default Backbone.Model.extend({
    backend: 'gcapi',

    urlRoot: '/device-service/sensors',

    url: function() {
        return this.urlRoot;
    },
    parse: function(response) {
        return {
            sensors: response ? response : []
        };
    }
});
